export default {
  "home": "ホーム",
  "news": "最新情報",
  "community": "コミュニティ",
  "character": "キャラクター紹介",
  "world": "世界観",
  "features": "ゲーム紹介",
  "topUp": "チャージ",
  "customerService": "お問い合わせ",
  "download": "今すぐダウンロード",
  "moreDownload": "ダウンロード情報",
  "screenshot": "スクリーンショット",
  "video": "動画",
  "poster": "ギャラリー",
  "downloadGame": "ダウンロード",
  "scan": "QRコードからダウンロード",
  "prev": "前へ",
  "next": "次へ",
  "moreNews": "もっと見る",
  "latest": "最新",
  "fwtk": "利用規約",
  "yszc": "プライバシーポリシー",
  "noContent": "内容がありません。",
  "goPay": "向かう",
  "payGuide": "詳細内容",
  "stayTurn": "お楽しみに",
  "back": "戻る",

}
